<template>
  <div class="forget">
    <van-sticky>
      <div class="header">
        <van-icon name="arrow-left" color="#fff" class="vanIcon" @click="returnIndex" />
        <span class="addInfo">重置密码</span>
      </div>
    </van-sticky>
    <div class="forget_content">
      <div class="user">
        <img src="../../assets/img/user.png" alt="" class="userImg" />
        <input type="text" class="input" placeholder="请输入用户名" v-model="form.username" />
      </div>
      <div class="user" style="margin-top: 1.2rem">
        <img src="../../assets/img/newPsw.png" alt="" class="userImg" />
        <input type="text" class="input" placeholder="请输入密码" v-model="form.newPsw" />
      </div>
    </div>
    <div class="forgetButton" @click="onLogin">登录</div>

  </div>
</template>
<script>
  import {
    resetPassword
  } from '@/axios/api'
  export default {
    data() {
      return {
        form: {},
        countdown: '',
        show: false,
        timer: null
      }
    },
    created() {},
    methods: {
      returnIndex() {
        this.$router.push('/')
      },
      onLogin() {
        if (this.form.username == "" || !this.form.username) {
          this.$toast({
            message: '手机号码不能为空',
            position: 'top',
          });
          return
        } else if (this.form.newPsw == "" || !this.form.newPsw) {
          this.$toast({
            message: '请输入密码',
            position: 'top',
          });
          return
        } else {
          let data = {
            userName: this.form.username,
            password: this.$md5(this.form.newPsw)
          }
          resetPassword(data).then((res) => {
            if (res.result == true) {
              console.log(res)
              this.$toast.success('密码重置成功');
              this.$router.push('/login')
            } else {
              console.log(res.errMsg)
              this.$toast.fail(res.errMsg);
            }
          }).catch((err) => {
            this.$toast.fail(err);
            console.log(err)
          })
        }
      },
    }
  }

</script>
<style scoped>
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .forget_content {
    width: 86%;
    margin: 1rem auto;
  }

  .input {
    height: 2.5rem;
    border: none;
    background: #fff;
    display: block;
    outline: none;
    -webkit-appearance: button;
    font-size: 0.875rem;
    margin-left: 1rem;
    width: 100%;
  }

  .reset_psw {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .forgetButton {
    width: 86%;
    margin: 0 auto;
    height: 2.875rem;
    background: linear-gradient(122deg, #17bcc5 0%, #0164a8 100%);
    margin: 0 auto;
    border-radius: 5rem;
    text-align: center;
    line-height: 3rem;
    font-size: 0.875rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 2rem;
  }

  .verification {
    font-size: 0.75rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0364a8;
    margin-right: 3%;
  }

  .userImg {
    width: 1.2rem;
  }

  .user {
    display: flex;
    align-items: center;
  }

  .countdown {
    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #108ee9;
  }

  .vanIcon {
    position: absolute;
    left: 1.3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/resetPsw.vue